/*
 * Public API Surface of ng-orel-card-ipg
 */

export * from './lib/ng-orel-card-ipg.service';
export * from './lib/ng-orel-card-ipg.component';
export * from './lib/ng-orel-card-ipg.module';
